module.exports = __webpack_public_path__ + "img/main_mockup_Epayment.b417178a.png";